/* global gapi*/
import Config from 'Config';
import SteelCompass from 'services/SteelCompass';
import AuthActions from 'actions/Auth';

class Facebook {
  getLoginUrl() {
    return SteelCompass.request('auth', 'getFacebookLoginUrl').then(
      url => {
        window.location = url;
      },
      error => {
        AuthActions.loginError(error);
      }
    );
  }
}

export default new Facebook();



// WEBPACK FOOTER //
// ./src/js/services/Facebook.js